export const ENABLE_LIVE_WARNING = 'FO982J-DJHV2J-HCKNL2';
export const ENABLE_LIVE_WARNING_TRUE = 'C82SHD-M2JCO3-9PP22C';
export const SHOULD_SHOW_LIVE_WARNING = localStorage.getItem(ENABLE_LIVE_WARNING) === ENABLE_LIVE_WARNING_TRUE;
